import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface CanvasTooltipProps {
  x: number;
  y: number;
  text: ReactNode;
  className?: string; // Extra class on top of the shared canvasTooltip look
}

const OFFSET_PX = 10;

// Shared screen-space tooltip look, portaled to document.body so it can be positioned anywhere
// on the page regardless of where the caller lives in the React tree (inside or outside Canvas).
// Anchored top-right of (x, y) — the cursor or handle position — so it never covers what it labels.
const CanvasTooltip = ({ x, y, text, className }: CanvasTooltipProps) => {
  return createPortal(
    <div
      className={className ? `canvasTooltip ${className}` : "canvasTooltip"}
      style={{ left: x, top: y, transform: `translate(${OFFSET_PX}px, calc(-100% - ${OFFSET_PX}px))` }}
    >
      {text}
    </div>,
    document.body
  );
};

export default CanvasTooltip;
